export class VehicleGroup {
  constructor(
    public id: number,
    public name: string,
    public sideNumbers: string[],
    public groupType: string
  ) {}
}
